// Unpublished Work © 2026 Deere & Company.

import {applicationStatus} from './application-status';
import {combineReducers} from 'redux';
import {criteria} from './criteria';
import {DigitalUserSearch} from '../../state/struct/digital-user-search/digital-user-search';
import {facetOptions} from './facet-options';
import {labels} from './labels';
import {reducerTcombWrapper} from '@deere/cap-it-ui.redux-store-creator';
import {results} from './results';

export const getDigitalUserSearchCombinedReducer = () => {
    const combinedReducer = combineReducers({
        applicationStatus,
        criteria,
        facetOptions,
        labels,
        results
    });

    return reducerTcombWrapper.bind(
        this,
        {
            combinedReducer,
            stateStruct: DigitalUserSearch
        }
    );
};
